import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "demo-collapse" }
const _hoisted_2 = { class: "contendText" }
const _hoisted_3 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_filled = _resolveComponent("info-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_Check = _resolveComponent("Check")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.centerDialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
    title: "已实现功能",
    width: "30%",
    "align-center": "",
    onOpen: _ctx.handleDialogOpen
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.centerDialogVisible = false))
        }, {
          default: _withCtx(() => _cache[28] || (_cache[28] = [
            _createTextVNode("知道了")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_collapse, {
          modelValue: _ctx.activeName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
          accordion: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, {
              title: "",
              name: "1"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"color":"#67c23a","font-size":"25px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_info_filled)
                  ]),
                  _: 1
                }),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "contendTitle" }, "从0到1实现系统架构搭建", -1))
              ]),
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "contendText" }, [
                  _createElementVNode("div", null, "1:本系统采用前后端分离模式"),
                  _createElementVNode("div", null, " 2:前端Vue（Element Plus）,后端.Net8 WebApi,都是从0到1搭建系统，没有使用任何模板。适合任何阶段的开发者模仿搭建。 "),
                  _createElementVNode("div", null, " 3:观看搭建过程，关注【微信公众号】或查看首页【关于系统】栏目。 ")
                ], -1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, {
              title: "",
              name: "2"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"color":"#67c23a","font-size":"25px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Check)
                  ]),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "contendTitle" }, "已实现功能", -1))
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light",
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("架构")
                      ])),
                      _: 1
                    }),
                    _cache[7] || (_cache[7] = _createTextVNode("1:jwt身份验证 "))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light",
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("架构")
                      ])),
                      _: 1
                    }),
                    _cache[9] || (_cache[9] = _createTextVNode("2:Autofac依赖注入。 "))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light",
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("架构")
                      ])),
                      _: 1
                    }),
                    _cache[11] || (_cache[11] = _createTextVNode("3:全局异常捕获。 "))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light",
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("架构")
                      ])),
                      _: 1
                    }),
                    _cache[13] || (_cache[13] = _createTextVNode("4:Aop动态代理。 "))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light"
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("权限")
                      ])),
                      _: 1
                    }),
                    _cache[15] || (_cache[15] = _createTextVNode("5:用户角色授权 "))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light"
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("权限")
                      ])),
                      _: 1
                    }),
                    _cache[17] || (_cache[17] = _createTextVNode("6:菜单权限分配。 "))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light"
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode("权限")
                      ])),
                      _: 1
                    }),
                    _cache[19] || (_cache[19] = _createTextVNode("7:菜单按钮权限分配。 "))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light"
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode("权限")
                      ])),
                      _: 1
                    }),
                    _cache[21] || (_cache[21] = _createTextVNode("8:数据按钮权限规则。 "))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "mx-1",
                      effect: "Light",
                      type: "danger"
                    }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode("样式")
                      ])),
                      _: 1
                    }),
                    _cache[23] || (_cache[23] = _createTextVNode("9:按钮样式统一调度。 "))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, {
              title: "",
              name: "3"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"color":"#e6a23c","font-size":"25px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Edit)
                  ]),
                  _: 1
                }),
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "contendTitle" }, "正在开发功能（下次更新）", -1))
              ]),
              default: _withCtx(() => [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "contendText" }, [
                  _createElementVNode("div", null, " 1:数据行规则（根据规则显示不同数据） "),
                  _createElementVNode("div", null, " 如：同一个table列表中，张三能看到[董事长]这条数据，李四者不能 "),
                  _createElementVNode("div", { style: {"color":"red"} }, "说明：该功能属于颗粒级权限控制")
                ], -1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, {
              title: "",
              name: "4"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"color":"#f56c6c","font-size":"25px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Filter)
                  ]),
                  _: 1
                }),
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "contendTitle" }, "规划中的功能（高级、颗粒级权限）", -1))
              ]),
              default: _withCtx(() => [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "contendText" }, [
                  _createElementVNode("div", null, " 1:动态数据列权限控制（同一个列表，张三能看见员工的工资，李四者不能），该权限可以动态通过配置规则控制 "),
                  _createElementVNode("div", null, " 2:动态数据行权限控制（同一个列表，张三能看见部门领导的个人信息，李四者不能），该权限可以动态通过配置规则控制 "),
                  _createElementVNode("div", null, "3:可视化表单设计（动态拖拽设计表单）"),
                  _createElementVNode("div", null, "4:可视化审批流程设计（动态拖拽审批设计流程）"),
                  _createElementVNode("div", null, " 5:动态接口权限（可控动态制系统中所有接口使用权限），该权限可以动态通过配置规则控制 "),
                  _createElementVNode("div", null, "6:记录所有操作日志")
                ], -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen"]))
}